
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import InterviewTable from './components/interviewTable.vue'
import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'

export const statusMap = {
    all: {
        key: 0, name: '全部'
    },
    wait: {
        key: 1, name: '待回复'
    },
    agree: {
        key: 2, name: '已同意'
    },
    reject: {
        key: 3, name: '已拒绝'
    }
}

@Component({
    name: 'media-store',
    components: {
        FullLoading,
        ScrollTo,
        InterviewTable
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private curStatus = statusMap.all.key
    private statusMap = statusMap
    private interviews = []

    async mounted() {
        await this.getList()
        this.isLoading = false
    }
    @Watch('curStatus')
    private onStatusChange() {
        this.pageIndex = 1
        this.getList()
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(() => {
            // todo
        })
    }

    private async getList() {
        try {
            const params = {
                status: this.curStatus || undefined,
                page_index: this.pageIndex,
                page_size: this.pageSize
            }
            const result = await EnterpriseService.getInterviewList(params)
            console.log('采访列表接口返回:', result)
            if (result && result.status === 200 && result.data) {
                this.pageTotal = result.data.page_total || 0
                const list = result.data.list || []
                this.interviews = list.map((item: any) => ({
                    ...item,
                    user: item.user || { id: item.userId || '', name: '' },
                    company: item.company || { id: item.companyId || '', name: '' },
                    created_at: item.createdAt || item.created_at || '',
                    updated_at: item.updatedAt || item.updated_at || ''
                }))
            }
        } catch (e) {
            console.error('获取采访列表失败:', e)

        }
    }
}
